import AssignmentDialog from './template'

export default AssignmentDialog
